import React, { useState } from 'react'
import Header from './Header'
import PromptHistory from './PromptHistory'
import { useAuth } from '@/contexts/AuthContext'
import { Button } from '@/components/ui/button'
import { isGuestMode, isInIframe } from '@/utils/iframeDetector'

interface MainLayoutProps {
  children: React.ReactNode
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { user } = useAuth()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const isGuest = isGuestMode()
  const inIframe = isInIframe()

  return (
    <div className={`bg-white ${inIframe ? 'h-full' : 'min-h-screen'}`}>
      <Header />
      <div 
        className="flex" 
        style={inIframe 
          ? { height: 'calc(100% - 64px)' } 
          : { height: 'calc(100vh - 64px)' }
        }
      >
        {/* Mobile sidebar toggle - hide in guest mode */}
        {user && !isGuest && (
          <div className="lg:hidden fixed top-20 left-4 z-50">
            <Button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              variant="outline"
              size="sm"
              className="bg-white shadow-md"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </Button>
          </div>
        )}

        {/* Sidebar - only show if user is logged in and not in guest mode */}
        {user && !isGuest && (
          <>
            {/* Mobile overlay */}
            {sidebarOpen && (
              <div 
                className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
                onClick={() => setSidebarOpen(false)}
              />
            )}
            
            {/* Sidebar */}
            <div className={`${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 fixed lg:relative inset-y-0 left-0 z-50 lg:z-auto transition-transform duration-300 ease-in-out`}>
              <PromptHistory onClose={() => setSidebarOpen(false)} />
            </div>
          </>
        )}
        
        {/* Main content */}
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  )
}

export default MainLayout
